// SEO case studies portfolio data for Rankify Dev
// Each project represents a real client SEO case study delivered as a PDF report.
//
// HOW TO ADD A NEW CASE STUDY:
// 1. Put the PDF file inside: public/seo-case-studies/your-file-name.pdf
// 2. (Optional) Put a cover image inside: public/seo-case-studies/covers/your-file-name.jpg
// 3. Add a new object below
export const seoProjects = [
  {
    name: "Jiliko",
    slug: "jiliko",
    client: "Jiliko",
    domain: "jiliko1225ph.io",
    categories: ["iGaming SEO"],
    niche: "Online Casino & Gaming (Philippines)",
    duration: "March 2026 – May 2026 (3 Months)",
    pdf: "/seo-case-studies/jiliko.pdf",
    cover: "/seo-case-studies/covers/jiliko.jpg",
    type: "seo",
    featured: true,
    description:
      "Ranked the brand keyword from no rank to #8 on Google Philippines and grew monthly organic traffic from 0 to 3.4K within 3 months through on-page fixes and quality backlink building.",
  },
  {
    name: "Lix-it",
    slug: "lix-it",
    client: "Lix-it",
    domain: "lix-it.com",
    categories: ["SaaS SEO"],
    niche: "B2B SaaS / Data Intelligence",
    duration: "March 2026 – Present (5 Months)",
    pdf: "/seo-case-studies/lix-it.pdf",
    cover: "/seo-case-studies/covers/lix-it.jpg",
    type: "seo",
    featured: true,
    description:
      "Improved rankings for key API-related keywords (LinkedIn API, LinkedIn Jobs API, LinkedIn Profile API) and grew monthly organic traffic by 79%, from 1.4K to 2.5K, over 5 months.",
  },
  {
    name: "Printseekers",
    slug: "printseekers",
    client: "Printseekers",
    domain: "printseekers.com",
    categories: ["E-commerce SEO"],
    niche: "Print-on-Demand / Custom Wall Art",
    duration: "Dec 2025 – Jan 2026 (1 Month)",
    pdf: "/seo-case-studies/printseekers.pdf",
    cover: "/seo-case-studies/covers/printseekers.jpg",
    type: "seo",
    featured: false,
    description:
      "Moved commercial product keywords higher on page one and grew monthly organic traffic by 41.7%, from 1.2K to 1.7K, in just one month through on-page and off-page SEO.",
  },
  {
    name: "SkipTheGames",
    slug: "skipthegames",
    client: "SkipTheGames",
    domain: "skipthegames.us.com",
    categories: ["Classifieds SEO"],
    niche: "Adult Classified Listings",
    duration: "Nov 2025 – March 2026 (5 Months)",
    pdf: "/seo-case-studies/skipthegames.pdf",
    cover: "/seo-case-studies/covers/skipthegames.jpg",
    type: "seo",
    featured: false,
    description:
      "Pushed three brand and city-specific keywords into Google's Top 10 and improved another keyword by 53 positions through targeted on-page and off-page SEO across city landing pages.",
  },
  {
    name: "SMM Panel",
    slug: "smm-panel",
    client: "SMM Panel",
    domain: "smmpanel.co",
    categories: ["SaaS SEO"],
    niche: "Social Media Marketing Services",
    duration: "August 2021 – August 2023 (2 Years)",
    pdf: "/seo-case-studies/smm-panel.pdf",
    cover: "/seo-case-studies/covers/smm-panel.jpg",
    type: "seo",
    featured: true,
    description:
      "Delivered 7.5x organic traffic growth over two years, from 4K to 30K+ monthly visitors, while ranking 10-15 new commercial keywords and expanding visibility into the Turkish market.",
  },
  {
    name: "Angkasa138",
    slug: "angkasa138",
    client: "Angkasa138",
    domain: "angkasa138.wordpress.com",
    categories: ["iGaming SEO"],
    niche: "Online Casino & Gaming",
    duration: "April 2026 – May 2026 (2 Months)",
    pdf: "/seo-case-studies/angkasa138.pdf",
    cover: "/seo-case-studies/covers/angkasa138.jpg",
    type: "seo",
    featured: true,
    description:
      "Took the main brand keyword from #8 to #1 on Google and grew monthly organic traffic roughly 55x, from 176 to 9.8K, in just two months.",
  },
  {
    name: "Balkan Trails",
    slug: "balkan-trails",
    client: "Balkan Trails",
    domain: "balkantrails.com",
    categories: ["Travel SEO"],
    niche: "Travel & Tour Packages",
    duration: "Jan 2026 – Feb 2026 (1 Month)",
    pdf: "/seo-case-studies/balkan-trails.pdf",
    cover: "/seo-case-studies/covers/balkan-trails.jpg",
    type: "seo",
    featured: false,
    description:
      "Moved the 'Tours to Romania' keyword from #10 to #3 on Google and grew monthly organic traffic by 7.3%, from 5.5K to 5.9K, in one month.",
  },
  {
    name: "Cygder",
    slug: "cygder",
    client: "Cygder",
    domain: "cygder.com",
    categories: ["iGaming SEO"],
    niche: "Online Casino & Gaming",
    duration: "Feb 2026 – May 2026 (4 Months)",
    pdf: "/seo-case-studies/cygder.pdf",
    cover: "/seo-case-studies/covers/cygder.jpg",
    type: "seo",
    featured: false,
    description:
      "Built a competitive casino keyword from no rank into Google's Top 10 and grew monthly organic traffic from just 4 to 1.3K visitors in four months.",
  },
  {
    name: "Emprada",
    slug: "emprada",
    client: "Emprada",
    domain: "emprada.com",
    categories: ["E-commerce SEO"],
    niche: "Fashion / Women's Clothing",
    duration: "April 2026 – Present (4 Months)",
    pdf: "/seo-case-studies/emprada.pdf",
    cover: "/seo-case-studies/covers/emprada.jpg",
    type: "seo",
    featured: false,
    description:
      "Achieved 87% organic traffic growth for a fashion e-commerce store, increasing monthly organic traffic from 5.5K to 10.3K through category-page optimization and quality backlinks.",
  },
  {
    name: "Happy Pharmacy",
    slug: "happy-pharmacy",
    client: "Happy Pharmacy",
    domain: "happypharmacy.co.uk",
    categories: ["Healthcare SEO"],
    niche: "Online Pharmacy & Healthcare",
    duration: "Jan 2026 – Feb 2026 (1 Month)",
    pdf: "/seo-case-studies/happy-pharmacy.pdf",
    cover: "/seo-case-studies/covers/happy-pharmacy.jpg",
    type: "seo",
    featured: false,
    description:
      "Took a target healthcare keyword from no ranking to the Top 40 on Google and grew monthly organic traffic by over 70%, from 1.8K to 3.1K, in just one month.",
  },
  {
    name: "Maple Grand",
    slug: "maple-grand",
    client: "Maple Grand",
    domain: "maplegrand.com",
    categories: ["Hospitality SEO"],
    niche: "Hotel & Hospitality (Agra)",
    duration: "Nov 2024 – June 2025 (8 Months)",
    pdf: "/seo-case-studies/maple-grand.pdf",
    cover: "/seo-case-studies/covers/maple-grand.jpg",
    type: "seo",
    featured: true,
    description:
      "Grew organic keywords from 71 to 123 and pushed 11 local hotel and restaurant keywords from no rank onto Google's first page, growing monthly organic traffic from 3.8K to 4.6K over 8 months.",
  },
  {
    name: "Hotel Sunring",
    slug: "hotel-sunring",
    client: "Hotel Sunring",
    domain: "hotelsunring.com",
    categories: ["Hospitality SEO"],
    niche: "Boutique Hotel (Agra)",
    duration: "Nov 2024 – June 2025 (8 Months)",
    pdf: "/seo-case-studies/hotel-sunring.pdf",
    cover: "/seo-case-studies/covers/hotel-sunring.jpg",
    type: "seo",
    featured: false,
    description:
      "Increased organic keywords from 10 to 106 and ranked multiple boutique hotel keywords near the Taj Mahal from no rank onto page one, growing monthly organic traffic 30.5x, from 2 to 61.",
  },
];

// Filter categories for the SEO portfolio page
export const seoFilterCategories = [
  "All Projects",
  "iGaming SEO",
  "E-commerce SEO",
  "SaaS SEO",
  "Travel SEO",
  "Healthcare SEO",
  "Hospitality SEO",
  "Classifieds SEO",
];

export const getSeoProjectsByCategory = (category) =>
  category === "All Projects"
    ? seoProjects
    : seoProjects.filter((p) => p.categories.includes(category));

export const getSeoFeaturedProjects = () =>
  seoProjects.filter((p) => p.featured);

export const getSeoCategoryCount = (category) => {
  if (category === "All Projects") return seoProjects.length;
  return getSeoProjectsByCategory(category).length;
};
